import * as camsAndForecastsPath from './camsAndForecastsPath';

export const { mapPath } = camsAndForecastsPath;
export const { geonameMapPath } = camsAndForecastsPath;
export spotForecastPath, { spotReportPath } from './spotForecastPath';
export subregionForecastPath, { premiumAnalysisLinkMap } from './subregionForecastPath';
